/* Wraps all tables with bootstraps responsive table class */
$('table').wrap('<div class="table-responsive"></div>');